import { TRUEMED_COUNTRIES } from 'lib/constants/localisation';

export const isTruemedCountry = (countryCode: string) =>
  TRUEMED_COUNTRIES.includes(countryCode);
